import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../services/session.service';
import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {
  constructor(
    private session: SessionService,
    private spinner: SpinnerService
  ) {}

  ngOnInit() {
    this.spinner.showSpinner('Logging you out...');
    this.session.terminate();
  }
}
